import { useMemo } from 'react';

import { CellRendererMap, DataTableColumnType } from './DataTable.types';

import {
    CommentCellRenderer,
    DateCellRenderer,
    GradientTextCellRenderer,
    TextCellRenderer,
    LastStatusUpdateCellRenderer,
    DatePickerCellRenderer,
    NumberCellRenderer,
} from './components/CellRenderers';

const DEFAULT_CELL_RENDERERS: CellRendererMap = {
    [DataTableColumnType.COMMENT]: CommentCellRenderer,
    [DataTableColumnType.DATE_FORMAT]: DateCellRenderer,
    [DataTableColumnType.TEXT]: TextCellRenderer,
    [DataTableColumnType.GRADIENT_TEXT]: GradientTextCellRenderer,
    [DataTableColumnType.DATE_PICKER]: DatePickerCellRenderer,
    [DataTableColumnType.LAST_STATUS_UPDATE]: LastStatusUpdateCellRenderer,
};

const useCellRenderers = (customRenderers?: CellRendererMap): CellRendererMap => {
    return useMemo(() => {
        return {
            ...DEFAULT_CELL_RENDERERS,
            ...customRenderers,
        };
    }, [customRenderers]);
};

export default useCellRenderers;
